import { Controller } from "@hotwired/stimulus";

const STORAGE_KEY = "consoleMode";

export default class extends Controller {
  static targets = ["tab", "section"];

  connect() {
    const modes = this.sectionTargets.map((el) => el.dataset.mode);
    if (modes.length < 2) return;

    const activeSection = this.sectionTargets.find((el) =>
      el.querySelector(".menu-active"),
    );
    const stored = window.localStorage.getItem(STORAGE_KEY);
    const mode =
      activeSection?.dataset.mode ||
      (modes.includes(stored) ? stored : modes[0]);

    this._apply(mode);
    window.localStorage.setItem(STORAGE_KEY, mode);
  }

  switch(event) {
    const mode = event.params.mode;
    this._apply(mode);
    window.localStorage.setItem(STORAGE_KEY, mode);
  }

  _apply(mode) {
    this.sectionTargets.forEach((el) => {
      el.hidden = el.dataset.mode !== mode;
    });
    this.tabTargets.forEach((el) => {
      el.classList.toggle(
        "btn-active",
        el.dataset.consoleModeModeParam === mode,
      );
    });
  }
}
